<template>
  <div class="payment-account-transfer-done">
    <button @click.prevent="onClose"
            class="payment-account-transfer-done__close">
      <BaseSvg name="ico-close"/>
    </button>
    <img src="@/assets/img/payment/payment-account-payment-done.svg"
         alt="message"
         class="payment-account-transfer-done__img">
    <div v-html="text"
         class="payment-account-transfer-done__text text">
    </div>
    <div class="payment-account-transfer-done__footer">

      <button @click.prevent="onClose"
              class="payment-account-transfer-done__btn  base-btn  base-btn--green">
        {{$tPayment('Continue working')}}
      </button>
      <button v-if="onRejectRecurring" @click.prevent="onRejectRecurring"
              class="payment-account-transfer-done__btn  base-btn  base-btn--outline-orange">
        <BaseSvg name="ico-trash" width="1.4rem" height="1.6rem"/>
        <span>{{$tPayment('Cancel regular payment')}}</span>
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PaymentAccountTransferDone',
    props: {
      text: String,
      onRejectRecurring: Function
    },
    data() {
      return {}
    },
    methods: {
      onClose() {
        this.$vModal.close('payment-account-transfer-done')
      }
    }
  }
</script>

<style lang="less">

</style>
